// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"c67f72ba","119":"5e07b7d8","398":"ba8e83a3","484":"bed05441","613":"ca1398c7","647":"9f545fa7","680":"57f16743","702":"f677f5bd","794":"71151a90"}[chunkId] + ".js";
};